module.exports = __webpack_public_path__ + "img/bg-contact.4621b402.jpg";